import { camelCase, isArray, isObject, snakeCase, transform } from 'lodash-es'

export const isBlank = (value) => value === undefined || value === null || !String(value).trim()

export const camelize = (obj) => transform(obj, (acc, value, key, target) => {
  const camelKey = isArray(target) ? key : camelCase(key)

  acc[camelKey] = isObject(value) ? camelize(value) : value
})

export const snakeize = (obj, ignoreKeys = []) => transform(obj, (acc, value, key, target) => {
  const camelKey = isArray(target) || ignoreKeys.includes(key) ? key : snakeCase(key)

  acc[camelKey] = isObject(value) ? snakeize(value, ignoreKeys) : value
})
